import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-phone-field',
  templateUrl: './phone-field.component.html',
  styleUrls: ['./phone-field.component.css']
})
export class PhoneFieldComponent implements OnInit {
  parts: FormGroup;
  constructor(private formBuilder: FormBuilder, ) {
  }

  ngOnInit() {
    this.parts = this.formBuilder.group({
      area: '',
      exchange: '',
      subscriber: '',
    });
  }

}
